import { render, staticRenderFns } from "./ParamScaleRangeList.vue?vue&type=template&id=3c1a2d92&scoped=true"
import script from "./ParamScaleRangeList.vue?vue&type=script&lang=js"
export * from "./ParamScaleRangeList.vue?vue&type=script&lang=js"
import style0 from "./ParamScaleRangeList.vue?vue&type=style&index=0&id=3c1a2d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a2d92",
  null
  
)

export default component.exports